import { Message } from "core/services/inbox.service";
import PagerStore from "core/stores/pager.store";
import { action, makeObservable, observable } from "mobx";

const sortMessages = (a: Message, b: Message) => {
    if (a.date == b.date) {
        return 0;
    }
    
    return a.date > b.date ? -1 : 1;
}

class InboxStore extends PagerStore<Message> {
    messages: Message[] = [];
    categories: string[] = [];
    category?: string = undefined;
    searchNeedle?: string = undefined;
    selectedMessage?: Message = undefined;
    isLoading: boolean = false;

    constructor(itemsPerPage = 5) {
        super(itemsPerPage);

        makeObservable(this, {
            categories: observable,
            messages: observable,
            category: observable,
            isLoading: observable,
            selectedMessage: observable,
            updateCategory: action,
            updateCategories: action,
            updateMessages: action,
            search: action
        });
    }

    search(value?: string) {
        const isMatch = (message: Message) => {
            if (!!this.category &&
                this.category !== message.category.title) {
                console.log("Skipping", message.id);
                return false;
            }

            if (!value) {
                return true;
            }

            const needle = value.toLowerCase();

            const { title, summary } = message.content;
            const details = message.content.details;

            const contains = (value: string) => value.toLowerCase().includes(needle);

            return contains(title) ||
                contains(summary) ||
                contains(details.title) ||
                contains(details.content);
        }

        const filteredMessages = this.messages.filter(x => isMatch(x));

        this.updateItems(filteredMessages);
    }

    updateItems(items: Message[]) {
        items.sort(sortMessages);

        super.updateItems(items);
    }

    updateMessages(value: Message[]) {
        this.messages = value;
        this.updateItems(value);
    }

    updateCategory(value?: string) {
        this.category = value;

        if (!value) {
            this.updateItems(this.messages);
            return;
        }

        const filteredMessages = this.messages.filter(x => x.category.title === value);

        this.updateItems(filteredMessages);
    }

    updateCategories(value: string[]) {
        this.categories = value;
    }

    updateIsLoading(value: boolean) {
        this.isLoading = value;
    }

    updateSelectedMessage(value?: Message) {
        this.selectedMessage = value;
    }
}

export default InboxStore;